export const QueryKey = {
	content: 'content',
	assets: 'assets',
	projects: 'projects',
	landscapeModules: 'landscape-modules',
	productModules: 'product-modules',
	creatorProductModules: 'creator-product-modules',
	creatorLandscapeModules: 'creator-landscape-modules',
	productModuleCollections: 'product-module-collections',
	productModuleCategories: 'product-module-categories',

	presets: 'presets',

	attributes: 'attributes',
	attributeValues: 'attribute-values',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
